import { Store, Module, ActionContext } from "vuex";
import ListModule from "./list-module";
import ListState from "./list-state";
import Ticket from "../entities/ticket";
import Ajax from "../../lib/ajax";
import PageResult from "@/store/entities/page-result";

interface TicketState extends ListState<Ticket> {
    editTicket: Ticket;
    permissions: Array<string>;
    treePermissions: Array<TreePermission>;
}

interface TreePermission {
    title: string;
    checked: boolean;
    expand: boolean;
    children: Array<TreePermission>;
}
class TicketModule extends ListModule<TicketState, any, Ticket> {
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<Ticket>(),
        loading: false,
        editTicket: new Ticket(),
        permissions: new Array<string>(),
        treePermissions: new Array<TreePermission>()
    };
    actions = {
        async getAll(context: ActionContext<TicketState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get("/api/services/app/Ticket/GetAll", {
                params: payload.data
            });
            context.state.loading = false;
            let page = reponse.data.result as PageResult<Ticket>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },
        async create(context: ActionContext<TicketState, any>, payload: any) {
            await Ajax.post("/api/services/app/Ticket/CreateWithImages", payload.data);
        },
        async update(context: ActionContext<TicketState, any>, payload: any) {
            await Ajax.put("/api/services/app/Ticket/UpdateWithImages", payload.data);
        },
        async delete(context: ActionContext<TicketState, any>, payload: any) {
            await Ajax.delete("/api/services/app/Ticket/Delete?Id=" + payload.data.id);
        },
        async get(context: ActionContext<TicketState, any>, payload: any) {
            console.log(payload,'payload');
            let reponse = await Ajax.get("/api/services/app/Ticket/GetTicketById?Id=" + payload.id);
            return reponse.data.result as Ticket;
        },
        async deleteImg(
            context: ActionContext<TicketState, any>,
            payload: any
          ) {
            return await Ajax.delete(
              "/api/services/app/TicketImage/Delete?Id=" + payload.data.id
            );
          },
        async getAllPermissions(context: ActionContext<TicketState, any>) {
            let reponse = await Ajax.get("/api/services/app/Ticket/getAllPermissions");
            context.state.permissions = reponse.data.result.items;
        },
        
    };
    mutations = {
        setCurrentPage(state: TicketState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: TicketState, pagesize: number) {
            state.pageSize = pagesize;
        },
        edit(state: TicketState, ticket: Ticket) {
            state.editTicket = ticket;
        }
    };
}
const ticketModule = new TicketModule();
export default ticketModule;
